import type { EifRecord } from 'eolib';
import type { Client } from '@/client';

/** Use the same base-stat requirements as the equipment validation pipeline. */
export function ItemRequirementLine({line,item,client}:{line:string;item?:EifRecord|null;client:Client}) {
  if (!item || !line.startsWith('req:')) return <>{line}</>;
  const stats=client.baseStats;
  const checks:[string,number,number][]=[
    ['LVL',item.levelRequirement,client.level],['STR',item.strRequirement,stats.str],
    ['INT',item.intRequirement,stats.intl],['WIS',item.wisRequirement,stats.wis],
    ['AGI',item.agiRequirement,stats.agi],['CON',item.conRequirement,stats.con],
    ['CHA',item.chaRequirement,stats.cha],
  ];
  return <span>Requires: {checks.filter(([,need])=>need>0).map(([label,need,have])=><span key={label} style={{color:have<need?'#ff6b6b':undefined}} title={`You have ${have} ${label}`} data-requirement={label} data-unmet={have<need?'true':'false'}>{need} {label}{' '}</span>)}</span>;
}
